export default {
    type: 'panel',
    name: 'exitIntent',
    blocks: [
        {
            name: 'promo1',
            label: 'Offre 1',
            max: 1,
            type: 'html',
        },
        {
            name: 'promo2',
            label: 'Offre 2',
            max: 1,
            type: 'html',
        },
        {
            name: 'extra',
            label: 'Infos supplémentaires',
            max: 1,
            type: 'html',
        },
    ],
};
